// src/components/Tag.jsx
import React from "react";
import { Badge } from "components/ui/badge";

const Tag = ({ name, className = "", ...props }) => {
  return (
    <Badge
      variant="secondary"
      className={`rounded-full px-3 py-1 text-sm bg-primary/10 text-primary border-transparent ${className}`}
      {...props}
    >
      {name}
    </Badge>
  );
};

export default Tag;
